import { Routes } from '@angular/router';



export const GridDesignerRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./grid-list/grid-list.component').then(m => m.GridListComponent)
  },
  {
    path: 'template/:shortcode',
    loadComponent: () => import('./grid-layout/grid-layout.component').then(m => m.GridLayoutComponent)
  },
  {
    path: 'grid/:shortcode',
    loadComponent: () => import('./grid-layout/grid-layout.component').then(m => m.GridLayoutComponent)
  },
  {
    path: 'template',
    loadComponent: () => import('./grid-layout/grid-layout.component').then(m => m.GridLayoutComponent)
  },
  {
    path: 'grid',
    loadComponent: () => import('./grid-layout/grid-layout.component').then(m => m.GridLayoutComponent)
  }
];
